<template>
  <div style="background-color: #fff;border-bottom: 1px solid #ddd;">
    <el-tabs v-model="activeTab" @tab-click="handleClick" @tab-remove="handleClose" style="padding: 0px 10px">
      <el-tab-pane
          v-for="tab in tabs"
          :key="tab.path"
          :name="tab.path"
          :label="tab.name"
          closable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props: {
    tabs: Array,
    activeTab: String
  },
  emits: ['switch-tab', 'close-tab'],
  methods: {
    handleClick(path){
      //console.log(path);
      this.$emit('switch-tab', path.name);
    },
    handleClose(path) {
      //console.log(path);
      this.$emit('close-tab', path);
    }
  }
};
</script>

<style scoped>

/deep/.el-tabs__header{margin-bottom: 8px;}

/deep/ .el-tabs__item{
  background-color: #f5f5f5;
  color:#909399;
  margin:8px 2px 0px 2px;
  border-radius: 5px;
  padding: 0px 10px;
  height: 30px;
  line-height: 30px;
}

/deep/ .el-tabs__active-bar{
  height:0px;
}
/deep/.el-tabs__item.is-active{
  background-color: #74bdff;
  color:#fff;
}

/deep/.el-tabs--top .el-tabs__item.is-top:nth-child(2){
  padding-left: 10px;
}
/deep/ .el-tabs__item.is-top:last-child{
  padding-right: 10px;
}

/deep/ .el-tabs__nav-wrap::after{
  height: 0px;
}

/deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{
  color:#74bdff;
}


/deep/ .el-tabs__item.is-top:hover{
  color:#74bdff;
}
/deep/ .el-tabs__item.is-top.is-active:hover{
  color:#fff;
}



</style>
